<label for="comment" class="form-label fw-bold">Historial del reporte</label>
  <div *ngIf="currentState" class="mb-3">
    <label for="">Estado Actual: <!-- <span class="badge" [ngClass]="{
        'bg-primary': currentState.name === 'Creado',
        'bg-info text-dark': currentState.name === 'En Revisión',
        'bg-success': currentState.name === 'Aprobado',
        'bg-warning text-dark': currentState.name === 'En Corrección',
        'bg-danger': currentState.name === 'Rechazado'
        }">
            {{ currentState.name }}
        </span> -->
        {{ currentState.name }}
    </label>
</div>


<div class="table-responsive">
    <table *ngIf="reportHistories.length>0"
    class="table table-hover table-sm align-middle border border-secondary rounded-4">
    <thead class="table-primary text-center">
        <tr>
            <th>Estado</th>
            <th>Usuario</th>
            <th>Comentario</th>
            <th>Fecha</th>
        </tr>
    </thead>

    <tbody>
        <tr *ngFor="let history of reportHistories" class="text-center form-label-sm">
            <td>
<!--                 <span class="badge" [ngClass]="{
                'bg-primary': history.state.name === 'Creado',
                'bg-info text-dark': history.state.name === 'En Revisión',
                'bg-success': history.state.name === 'Aprobado',
                'bg-warning text-dark': history.state.name === 'En Corrección',
                'bg-danger': history.state.name === 'Rechazado'
                }">
                    {{ history.state.name }}
                </span> -->
               {{history.state.name}} 
            </td>
            <td>{{ history.user.name }}</td>
            <td>
                <p *ngIf="history.comment" class="text-center">
                    {{ history.comment }}
                </p>
                <p *ngIf="!history.comment" class="text-center">
                    Sin comentario
                </p>
            <td>{{ history.createdAt | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
        </tr>
    </tbody>

</table>
</div>



<p *ngIf="reportHistories.length==0">
    <span class="badge bg-secondary">No hay historial de cambios</span>
</p>